import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addElementsToLayout } from "./addElementsToLayout";

export const addPostsDataToLayout = (
  gridElements,
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.executiveSummary;

  Object.keys(campaigns).forEach((key) => {
    const campaign = campaigns[key];

    const {
      project: { title },
    } = campaign;

    if (!aggregation && key !== "aggregated") {
      addHeaderToLayout(`post-data-${title}`, newLayout, format, 3);
    }

    const gridElementsToAdd = gridElements.filter(
      (item) => item.gridBoxType === "post-data" && item.campaignId === key,
    );
    addElementsToLayout(gridElementsToAdd, newLayout, format, []);
  });
};
